import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectTemplateSpace = ()=>createSelector((state)=>state.templates.project.data, (_, { spaceId, templateId })=>({
            spaceId,
            templateId
        }), (data, { spaceId, templateId })=>{
        var _data_templateId_spaceList, _data_templateId;
        return data === null || data === void 0 ? void 0 : (_data_templateId = data[templateId]) === null || _data_templateId === void 0 ? void 0 : (_data_templateId_spaceList = _data_templateId.spaceList) === null || _data_templateId_spaceList === void 0 ? void 0 : _data_templateId_spaceList[spaceId];
    });
export const useProjectTemplateSpace = (spaceId)=>{
    const templateId = useActiveTemplateId();
    const spaceObject = useMemo(()=>getProjectTemplateSpace(), []);
    return useSelector((state)=>spaceObject(state, {
            spaceId,
            templateId
        }));
};
